module.exports = __webpack_public_path__ + "static/media/map-pin.d6163294.svg";